import Box from "@mui/material/Box";
import BlockRenderer from "components/BlockRenderer";
import axiosInstance from "interceptor/axiosInstance";
import { startTransition, useEffect, useState } from "react";
import { Meta } from "types/cms/Meta";
export default function Home({ lmpRef }: any) {
    const [data, setData] = useState<any>(null);
    const [meta, setMeta] = useState<Meta | null>(null);
    useEffect(() => {
        axiosInstance
            .get(`${process.env.REACT_APP_CMS_API_URL}/api/pages/1?depth=1&draft=false&locale=undefined`)
            .then((response: any) => {
                startTransition(() => {
                    setData(response.data);
                    setMeta(response.data.meta);
                });
            })
            .catch((error: any) => {
                console.log(error);
            });

        const timeout = setTimeout(() => {
            if (window.location.pathname === "/" && window.location.hash) {
                const element = document.getElementById(window.location.hash.slice(1));
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }
        }, 500);

        return () => clearTimeout(timeout);
    }, []);

    if (meta && meta.title && meta.description) {
        document.title = `${meta?.title} | CRASHLAW`;
        document.querySelector('meta[name="description"]')?.setAttribute("content", meta?.description ?? "");
        // og:description needs to be limited to 71 chars, so strip from the start if necessary
        const ogDescription = meta?.description ?? "";
        const trimmedOgDescription = ogDescription.length > 71 ? ogDescription.slice(-71) : ogDescription;
        document.querySelector('meta[property="og:description"]')?.setAttribute("content", trimmedOgDescription);
    }


    return (
        <Box>
            <BlockRenderer blocks={data?.layout} />
            {/* <CookieConsent
                location="bottom"
                buttonText="Accept all cookies"
                declineButtonText="Only essential"
                cookieName="cookie_consent"
                flipButtons={true}
                style={{
                    display: "flex",
                    alignItems: "center",
                    height: "286px",
                    width: "99%",
                    left: "10px",
                    backgroundImage: `url(${cookieBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "15px",
                    padding: "0 100px",
                }}
                buttonStyle={{
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Univia Pro",
                    backgroundColor: "#3399FF",
                    borderRadius: "100px",
                    padding: "10px 45px",
                }}
                declineButtonStyle={{
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Univia Pro",
                    backgroundColor: "#3399FF",
                    borderRadius: "100px",
                    padding: "10px 45px",
                }}
                expires={150}
                enableDeclineButton
                onAccept={() => {
                    loadTrackingScripts();
                }}
                onDecline={() => {
                    console.log("declined");
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", width: "340px" }}>
                    <Typography sx={{ fontSize: "30px", fontWeight: "700" }}>Cookie notice</Typography>
                    <Typography sx={{ fontWeight: "450", fontFamily: "Neue Haas Grotesk Display light", fontSize: "14px" }}>
                        This website employs cookies to improve user experience. If you continue on this website you will be providing your consent to our use of all cookies.
                    </Typography>

                    <Link to="/privacy-policy" style={{ color: "white", fontFamily: "Univia Pro", marginTop: "40px", fontWeight: "700", textDecoration: "underline", fontSize: "14px" }}>
                        Read our Privacy Policy here
                    </Link>
                </Box>
            </CookieConsent> */}
        </Box>
    );
}
